<template>
    <component :is="component" v-if="localized" v-bind="$props" />
    <div v-else>
        <div v-if="paymentPlan.description" class="payment-plan-description mx-1 mt-4">
            <span class="font-weight-bold">Description:</span>
            {{ paymentPlan.description }}
        </div>
    </div>
</template>

<script>
    import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin"

    export default {
        name: "PaymentPlanDescription",
        mixins: [LocalizedComponentMixin],
        props: {
            paymentPlan: {
                type: Object,
                required: true,
            },
            providerKey: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                componentType: "paymentPlanDescription",
            }
        },
    }
</script>

<style lang="scss">
    .payment-plan-description {
        font-size: 14px;
        line-height: 20px;
        font-weight: 350;
        display: flex;
        flex-wrap: wrap;
        text-wrap: wrap;
        max-width: 100%;
    }
</style>
